/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MonitoringService {
    /**
     * @returns string OK
     * @throws ApiError
     */
    public static getApiVMonitoringGsoa({
        service,
        apiVersion = 1,
    }: {
        service: 'actionOffers' | 'counter' | 'coupons' | 'customerProfile' | 'foodPickup' | 'gastro' | 'productCatalog' | 'recommender' | 'shoppingList',
        apiVersion?: number,
    }): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/monitoring/gsoa/{service}',
            path: {
                'apiVersion': apiVersion,
                'service': service,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public static getApiVMonitoring({
        service,
        apiVersion = 1,
    }: {
        service: 'elastic' | 'redis' | 'self' | 'storyblok' | 'yext',
        apiVersion?: number,
    }): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/monitoring/{service}',
            path: {
                'apiVersion': apiVersion,
                'service': service,
            },
        });
    }
    /**
     * @returns any Gsoa action offer images monitoring response
     * @throws ApiError
     */
    public static getApiVMonitoringGsoaActionOfferImages({
        apiVersion = 1,
    }: {
        apiVersion?: number,
    }): CancelablePromise<{
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/monitoring/gsoaActionOfferImages',
            path: {
                'apiVersion': apiVersion,
            },
        });
    }
}
